<template>
  <div class="subfleet">
    <!--
  <div class="fleet-items">
    <span
      class="section-label"
      v-text="$t('components.fleet.specialist')"
    ></span>
    <fleet-item-list
      :items="specialists"
      :drag-bus="dragBus"
      :simulation-bus="simulationBus"
      :item-type-selection-bus="itemTypeSelectionBus"
      :items-draggable="false"
      :allow-add-items="specialists.length === 0"
      :allow-edit-amounts="false"
      :item-group="'specialist-' + uid"
      @change="onItemListChanged"
      @itempictureclick="onSpecialistPictureClick"
      @additem="addSpecialist"
    />
  </div>
  <div class="fleet-items">
    <span
      class="section-label"
      v-text="$t('components.fleet.research')"
    ></span>
    <fleet-item-list
      :items="research"
      :drag-bus="dragBus"
      :simulation-bus="simulationBus"
      :item-type-selection-bus="itemTypeSelectionBus"
      :items-draggable="false"
      :item-width="'5rem'"
      :allow-add-items="research.length === 0"
      :allow-edit-amounts="false"
      :item-group="'research-' + uid"
      @change="onItemListChanged"
      @itempictureclick="onResearchPictureClick"
      @additem="addResearch"
    />
  </div>-->
    <div class="fleet-items">
      <span class="section-label" v-text="$t('components.fleet.ships')"></span>
      <fleet-item-list
        :items="ships"
        :drag-bus="dragBus"
        :simulation-bus="simulationBus"
        :item-type-selection-bus="itemTypeSelectionBus"
        :special-ship-bus="specialShipBus"
        :items-draggable="true"
        :item-width="'10rem'"
        :item-group="'ship' + uid"
        :allow-edit-amounts="false"
        @change="onItemListChanged"
        @itempictureclick="onShipPictureClick"
        @additem="addShip"
      />
    </div>
    <fleet-import-area
      role="debris_gatherer"
      @import="onImport"
    ></fleet-import-area>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import FleetImportArea from "@/components/fleet/FleetImportArea";
import Fleet from "@/store/model/fleet";
import Vue from "vue";
import FleetItemList from "@/components/fleet/FleetItemList";
import Ship from "@/store/model/ship";
import { FleetImporter } from "@/services/fleet-importer";
import Specialist from "@/store/model/specialist";

export default {
  name: "DebrisGathererFleet",
  components: {
    FleetItemList,
    FleetImportArea
  },
  props: {
    fleet: {
      type: Fleet,
      default: null
    },
    dragBus: {
      type: Vue,
      required: true
    },
    simulationBus: {
      type: Vue,
      default: null
    },
    itemTypeSelectionBus: {
      type: Vue,
      default: null
    },
    specialShipBus: {
      type: Vue,
      default: null
    }
  },
  data: () => {
    return {
      uid: null,
      specialists: [],
      research: [],
      ships: [],
      showImportArea: false,
      itemTypeSelectedCallback: null
    };
  },
  created() {
    this.uid = this.$uuid.v4();
    this.onFleetChanged();
  },
  destroyed() {
    this.releaseItemTypeSelectionListeners();
  },
  computed: {
    ...mapGetters("data", [
      "specialistTypes",
      "researchTypes",
      "shipTypes",
      "defenseTypes"
    ])
  },
  watch: {
    fleet() {
      this.onFleetChanged();
    },
    allowRemove() {
      setTimeout(() => {
        this.recalculateNameWidth();
      }, 1);
    }
  },
  methods: {
    ...mapActions("debris", ["markFleetChanged"]),
    onFleetChanged() {
      if (this.fleet.name.length === 0) {
        const nameKey =
          this.index === 0
            ? "components.fleet.unnamed_main_fleet"
            : "components.fleet.unnamed_alliance_fleet";
        this.fleet.name = this.$t(nameKey, {
          index: this.index
        });
      }
      this.specialists = this.fleet.specialists;
      this.research = this.fleet.research;
      this.ships = this.fleet.ships;
      this.defenses = this.fleet.defenses;
    },
    onNameKeydown(event) {
      setTimeout(() => {
        event.target.previousSibling.innerText = event.target.value;
        this.recalculateNameWidth();
      }, 1);
    },
    onItemListChanged() {
      this.markFleetChanged();
    },
    onImport(event) {
      if (event == null) {
        alert(this.$t("components.fleet.import_failed"));
        return;
      }
      FleetImporter.apply(this.fleet, event, this.role);
      this.$emit("import", event);
      this.markFleetChanged();
    },
    recalculateNameWidth() {
      const nameInput = this.$refs["nameInput"];
      nameInput.style.width = getComputedStyle(nameInput.previousSibling).width;
    },
    addSpecialist() {
      this.openItemTypeSelection(this.specialistTypes).then(typeId => {
        const entry = new Specialist(typeId);
        this.specialists.push(entry);
      });
    },
    addResearch() {
      FleetImporter.addDefaultTechs(this.research);
    },
    addShip() {
      this.openItemTypeSelection(this.shipTypes).then(typeId => {
        const entry = new Ship(typeId, 1);
        this.ships.push(entry);
      });
    },
    removeSubfleet() {
      this.$emit("remove");
    },
    onSpecialistPictureClick(entry) {
      this.openItemTypeSelection(this.specialistTypes, entry).then(typeId => {
        if (typeId === null) {
          const index = this.specialists.indexOf(entry.item);
          this.specialists.splice(index, 1);
        } else {
          entry.item.typeId = typeId;
          this.markFleetChanged();
        }
      });
    },
    onResearchPictureClick() {
      /*
    this.openItemTypeSelection(this.researchTypes, entry).then(typeId => {
      if (typeId === null) {
        const index = this.research.indexOf(entry.item);
        this.research.splice(index, 1);
      } else {
        entry.typeId = typeId;
        this.markFleetChanged();
      }
    });
    */
    },
    onShipPictureClick(entry) {
      this.openItemTypeSelection(this.shipTypes, entry).then(typeId => {
        if (typeId === null) {
          const index = this.ships.indexOf(entry.item);
          this.ships.splice(index, 1);
        } else {
          entry.item.typeId = typeId;
          this.markFleetChanged();
        }
      });
    },
    openItemTypeSelection(itemTypes, entry = null) {
      return new Promise(resolve => {
        this.itemTypeSelectedCallback = resolve;
        this.hookItemTypeSelectionListeners();
        const posY =
          this.$el.getBoundingClientRect().bottom -
          this.$el.parentNode.getBoundingClientRect().top +
          this.$el.parentNode.scrollTop;
        this.itemTypeSelectionBus.$emit("show", {
          entry: entry,
          itemTypes: itemTypes,
          selected: entry != null ? entry.item.typeId : null,
          allowNull: entry != null,
          posY: posY
        });
      });
    },
    onItemTypeSelected(itemType) {
      if (this.itemTypeSelectedCallback != null) {
        this.itemTypeSelectedCallback(itemType != null ? itemType.key : null);
      }
      this.simulationBus.$emit("simulate");
      this.markFleetChanged();
      this.releaseItemTypeSelectionListeners();
    },
    onItemTypeSelectionCancelled() {
      this.releaseItemTypeSelectionListeners();
    },
    hookItemTypeSelectionListeners() {
      this.itemTypeSelectionBus.$on("select", this.onItemTypeSelected);
      this.itemTypeSelectionBus.$on(
        "cancel",
        this.onItemTypeSelectionCancelled
      );
    },
    releaseItemTypeSelectionListeners() {
      this.itemTypeSelectedCallback = null;
      this.itemTypeSelectionBus.$off("select", this.onItemTypeSelected);
      this.itemTypeSelectionBus.$off(
        "cancel",
        this.onItemTypeSelectionCancelled
      );
    }
  }
};
</script>

<style scoped>
.subfleet:before,
.subfleet > .header:before,
.subfleet > .header:after {
  box-sizing: border-box;
  border-top: var(--border-reg);
}

.subfleet {
  position: relative;
  padding: 1em 0;
}

.subfleet:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top-color: transparent;
  pointer-events: none;
}

.subfleet > .header {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.subfleet > .header:before,
.subfleet > .header:after {
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  height: 1px;
  pointer-events: none;
}

.subfleet > .header:before {
  content: "";
  width: 1em;
  border-top-right-radius: 0;
}

.subfleet > .header:after {
  content: "";
  flex: 1;
  border-top-left-radius: 0;
}
.subfleet > .header > textarea,
.subfleet .remove-subfleet {
  position: relative;
  top: -0.72em;
  line-height: 1em;
  font-size: 1rem;
  height: 1.4em;
}
.subfleet > .header > textarea {
  margin-left: 0.5em;
  margin-right: -0.5em;
  background: transparent;
  border: none;
  font-size: 1em;
  padding: 0.2em 0;
  overflow: hidden;
  resize: none;
}

.subfleet .remove-subfleet {
  display: inline-block;
  width: 1em;
  left: -0.5em;
}

.section-label {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1em;
  width: 100%;
  margin-top: 0.5em;
  margin-bottom: 1em;
}
</style>
